// extracted by mini-css-extract-plugin
export default {"headerTitle":"PageTitle_headerTitle__Yhofq","headerTitleContainer":"PageTitle_headerTitleContainer__ke-n-","headerSubTitleContainer":"PageTitle_headerSubTitleContainer__xWSUT"};